module.exports = __webpack_public_path__ + "static/media/01_A5_03.8f1630a9.png";